// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__S+0l3"};